// Imports
import React, { useEffect, useState } from "react";
import { useQuiz } from "src/contexts/QuizContext.js";
import tick from "src/files/tick.svg";
import ky from "ky";
import QuizButtonClose from "../../QuizButtonClose/jsx/index.jsx";
import { getAllQuizAnswers } from "../../QuizHelpers/index.js";
import fetchConfigMockdata from "../fetchConfigMockdata.json";

function QuizScreenFinish() {
  const { quizStatus, questions, dispatch } = useQuiz();
  const [quizConfig, setQuizConfig] = useState([]);
  const [loading, setLoading] = useState({
    message: "Loading your recommendations...",
    class: "quiz-screen-finish__subtitle",
    status: "loading",
  });

  const shuffleArray = (arr) =>
    arr
      .map((a) => [Math.random(), a])
      .sort((a, b) => a[0] - b[0])
      .map((a) => a[1]);

  const saveBookmarks = (articles = []) => {
    let bookmarkAdded = false;
    if (articles.length) {
      articles.forEach((a) => {
        // add the bookmark if not already stored
        if (
          a.can_bookmark &&
          !window.squiz.fn.BookmarkStorage.isBookmarked(a.id)
        ) {
          window.squiz.fn.BookmarkStorage.addBookmark(a);
          bookmarkAdded = true;
        }
      });
    }
    return bookmarkAdded;
  };

  // Capture all quiz answers when quiz completes
  const captureQuizAnswers = () => {
    const allAnswers = getAllQuizAnswers(questions);

    // Transform allAnswers into an object with questionTitle as key and answer as value
    const answersObject = {};
    allAnswers.forEach(question => {
      if (question.answers.length > 1) {
        // If question has multiple answers, loop through each answer
        question.answers.forEach(answer => {
          const key = `${question.questionTitle}: ${answer.sectionTitle}`;
          answersObject[key] = answer.answer;
        });
      } else {
        // For single answer questions, use just the question title
        answersObject[question.questionTitle] = question.answers[0].answer;
      }
    });

    // Log captured answers for debugging
    console.log("Quiz completed with answers:", allAnswers);
    
    // Display the transformed answers in a table format
    console.table(answersObject);

    return allAnswers;
  };

  // calculate a score count and search config and store the ids
  const mapArticleScores = () => {
    // store all transformed articles
    let transformedArticles = { H: [], M: [], L: [] };

    // Q2 only vehicle for condition
    const q1 = questions["question2"].subquestions["section1"].savedAnswer;
    const a1 = q1 !== "Never";

    const pKeys = Object.keys(questions);
    pKeys.forEach((qKey) => {
      const sections = Object.keys(questions[qKey].subquestions);
      sections.forEach((sKey) => {
        const section = questions[qKey].subquestions[sKey];
        const answer = section.savedAnswer;
        const scoreKeys = Object.keys(section.score);
        if (scoreKeys.length) {
          scoreKeys.forEach((scoreKey) => {
            let scored = false;

            if (scoreKey.includes(answer)) {
              // check conditional question 8
              if (qKey === "question8" && sKey == "section1" && a1) {
                console.log("[score match Q9]");
                scored = true;

                // check conditional question 9
              } else if (qKey === "question9" && sKey == "section1" && a1) {
                console.log("[score match Q9]");
                scored = true;
                // add score else
              } else {
                console.log(`[score match logic ${qKey}]`);
                scored = true;
              }

              if (scored) {
                // find article
                const match = quizConfig.find((c) => {
                  const score = section?.score[scoreKey];
                  return (
                    c.questionKey === qKey &&
                    c.sectionKey === sKey &&
                    c.score.trim() === score.trim()
                  );
                });

                // add matches articles to articles array
                if (typeof match !== "undefined") {
                  // get the normalised score eg: M would match M, MYES, MNO etc.. or M(Anything)
                  const normalisedScore = match.score.charAt(0);
                  // merge the matches articles into the transformed array under the correct collections
                  // eg: H:[], M:[], L:[]
                  if (match.articles.length) {
                    const newArticles = [
                      ...transformedArticles[normalisedScore],
                      ...match.articles,
                    ];
                    transformedArticles = {
                      ...transformedArticles,
                      [normalisedScore]: newArticles,
                    };
                  }
                }
              }
            }
          });
        }
      });
    });

    // shuffle combined articles in priority
    let randomArticles = [
      ...shuffleArray(transformedArticles.H),
      ...shuffleArray(transformedArticles.M),
      ...shuffleArray(transformedArticles.L),
    ];

    // remove duplicates
    //randomArticles = [...new Set(randomArticles)];
    randomArticles = randomArticles.filter(
      (obj1, i, arr) => arr.findIndex((obj2) => obj2.id === obj1.id) === i
    );

    //console.log("[randomArticles - no dups]", randomArticles);

    if (randomArticles.length) {
      // recommendations ready
      setLoading({
        message: "Your recommendations are ready.",
        class: "quiz-screen-finish__title",
        status: "success",
      });

      // save articles in context
      const slicedArticles = randomArticles.slice(0, 5);

      //console.log("[slicedArticles]", slicedArticles);
      dispatch({
        type: "setArticles",
        payload: {
          articles: slicedArticles, // save up to 5 articles
        },
      });

      // dispatch recommendations
      setTimeout(() => {
        dispatch({
          type: "quizStatus",
          payload: {
            value: "recommendations",
          },
        });

        // save bookmarks and generate an alert if one or more have been saved
        if (saveBookmarks(slicedArticles)) {
          const config = {
            content: `Your recommended resources have been saved to your bookmarks automatically so you can consult them anytime.`,
            active: true,
            theme: "sand",
            toFront: true,
            forBookmark: true,
          };
          new window.squiz.fn.Notification(config);
        }
      }, 2000);
    } else {
      // no articles
      setLoading({
        message: "No recommendations were found, please restart the quiz.",
        class: "quiz-screen-finish__subtitle",
        status: "notfound",
      });

      console.log("[dispatch recommendations] no articles found");
    }
  };

  // fetch config
  const fetchQuizConfig = async () => {    
    try {
      const endpoint = process.env.QUIZ_CONFIG_ENDPOINT;
      let config = await ky.get(endpoint).json();
      
      // Use to get to recommendations screen
      // Example of what config is set to in fetchQuizConfig function
      // let config = await fetchConfigMockdata;

      setQuizConfig(config);
    } catch (e) {
      setLoading({
        message: "There seems to be a problem, please try the quiz again.",
        class: "quiz-screen-finish__subtitle",
        status: "error",
      });
      console.log(`[ky error] ${e}`);
    }
  };

  // fetch config on quizStatus completed
  useEffect(() => {
    if (quizStatus === "completed") {
      const allAnswers = captureQuizAnswers();
      
      // Store in context using dispatch
      dispatch({
        type: "setQuizAnswers",
        payload: {
          answers: allAnswers,
        },
      });

      setTimeout(() => {
        fetchQuizConfig();
      }, 1500);
    }
  }, [quizStatus]);

  // wait for config to popuload then call API
  useEffect(() => {
    if (quizConfig.length) mapArticleScores();
  }, [quizConfig]);

  return (
    <>
      <div className="quiz-screen-finish screen--loading">
        {quizStatus == "completed" && <QuizButtonClose />}
        <div className="quiz-screen-finish__icon">
          <div className="quiz-screen-finish__icon-wrapper">
            <img className="quiz-screen-finish__icon-tick" src={tick} alt="" />
          </div>
          <p aria-live="polite" className={loading.class}>
            {loading.message}
          </p>
        </div>
      </div>
    </>
  );
}

export default QuizScreenFinish;
